import * as Sentry from '@sentry/react';
import { useEffect, useState } from 'react';
import { getClientToken } from '~/api/payment';
import useScript, { SCRIPT_STATUS } from './useScript';

class StripeLoadException extends Error {
  constructor(error) {
    super(error);
    this.name = 'StripeLoadException';
  }
}

export function useStripe() {
  const [stripe, setStripe] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const stripeScriptStatus = useScript('https://js.stripe.com/v3/');

  useEffect(() => {
    async function loadStripe() {
      switch (stripeScriptStatus) {
        case SCRIPT_STATUS.READY: {
          try {
            const { stripePublishableKey } = await getClientToken();
            const stripe = Stripe(stripePublishableKey);
            setStripe(stripe);
            setIsLoading(false);
          } catch (e) {
            Sentry.captureException(new StripeLoadException(e));
            setError(e.message);
          }
          break;
        }

        case SCRIPT_STATUS.ERROR: {
          setError('Stripe SDK failed to load');
          break;
        }

        case SCRIPT_STATUS.IDLE:
        case SCRIPT_STATUS.LOADING:
        default: {
          setIsLoading(true);
          break;
        }
      }
    }
    loadStripe();
  }, [stripeScriptStatus]);

  return {
    stripe: stripe,
    isStripeLoading: isLoading,
    isStripeReady: stripe && !isLoading && !error,
    stripeError: error,
  };
}
